export const sendEvent = (eventName: string, data?: object) => {
  let event;

  if (data) {
    event = new CustomEvent(eventName, { detail: data });
  } else {
    event = new Event(eventName);
  }

  document.dispatchEvent(event);
};
